/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import { CreditAppSavedSectionInfo } from '../../../apollo/fragments/CreditAppSavedSectionInfo.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateNameAndOwnershipData_updateCreditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo = { readonly __typename: 'CreditApplicationBusinessInfo', readonly legalBusinessName: string | null, readonly preferredAccountName: string | null, readonly website: string | null, readonly ownership: _Types.CreditApplicationBusinessOwnership | null, readonly naicsCode: string | null, readonly industry: string | null, readonly formedOn: any | null, readonly entityType: _Types.CreditApplicationBusinessEntity | null, readonly taxIdLastFour: string | null, readonly numberOfEmployees: number | null };

export type UpdateNameAndOwnershipData_updateCreditApplication_CreditApplication_savedSectionsInfo_SavedSectionsInfo = { readonly __typename: 'SavedSectionsInfo', readonly sectionName: _Types.SectionName, readonly completedAt: any | null, readonly completionStatus: _Types.CompletionStatus | null };

export type UpdateNameAndOwnershipData_updateCreditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly fetchedAt: any | null, readonly businessInfo: UpdateNameAndOwnershipData_updateCreditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo | null, readonly savedSectionsInfo: ReadonlyArray<UpdateNameAndOwnershipData_updateCreditApplication_CreditApplication_savedSectionsInfo_SavedSectionsInfo | null> | null };

export type UpdateNameAndOwnershipData_Mutation = { readonly __typename: 'Mutation', readonly updateCreditApplication: UpdateNameAndOwnershipData_updateCreditApplication_CreditApplication };


export type UpdateNameAndOwnershipDataVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
  businessInfo: _Types.BusinessInfoInput;
}>;


export type UpdateNameAndOwnershipData = UpdateNameAndOwnershipData_Mutation;


export const UpdateNameAndOwnershipDataDocument = gql`
    mutation UpdateNameAndOwnershipData($creditApplicationId: ID!, $businessInfo: BusinessInfoInput!) {
  updateCreditApplication(
    creditApplicationId: $creditApplicationId
    businessInfo: $businessInfo
  ) {
    salesforceCreditId
    fetchedAt
    businessInfo {
      legalBusinessName
      preferredAccountName
      website
      ownership
      naicsCode
      industry
      formedOn
      entityType
      taxIdLastFour
      numberOfEmployees
    }
    ...CreditAppSavedSectionInfo
  }
}
    ${CreditAppSavedSectionInfo}`;
export type UpdateNameAndOwnershipDataMutationFn = Apollo.MutationFunction<UpdateNameAndOwnershipData, UpdateNameAndOwnershipDataVariables>;

/**
 * __useUpdateNameAndOwnershipData__
 *
 * To run a mutation, you first call `useUpdateNameAndOwnershipData` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNameAndOwnershipData` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNameAndOwnershipData, { data, loading, error }] = useUpdateNameAndOwnershipData({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *      businessInfo: // value for 'businessInfo'
 *   },
 * });
 */
export function useUpdateNameAndOwnershipData(baseOptions?: Apollo.MutationHookOptions<UpdateNameAndOwnershipData, UpdateNameAndOwnershipDataVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNameAndOwnershipData, UpdateNameAndOwnershipDataVariables>(UpdateNameAndOwnershipDataDocument, options);
      }
export type UpdateNameAndOwnershipDataHookResult = ReturnType<typeof useUpdateNameAndOwnershipData>;
export type UpdateNameAndOwnershipDataMutationResult = Apollo.MutationResult<UpdateNameAndOwnershipData>;
export type UpdateNameAndOwnershipDataMutationOptions = Apollo.BaseMutationOptions<UpdateNameAndOwnershipData, UpdateNameAndOwnershipDataVariables>;